function isTelephone(evt, number) {
    evt = (evt) ? evt : window.event;
    let charCode = (evt.which) ? evt.which : evt.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault();
    }
    // restrict to length of number
    if(number != null && number.length > 9){
        evt.preventDefault();
    }
    else {
        return true
    }
}

export {
    isTelephone,
}
